module.exports = __webpack_public_path__ + "media/images/emblems/Benken-blazon-e54be036ce240ba2135fff007b79d9e9.svg";